<div class="container-fluid mlp-studio-tray-container" *ngIf="vm" [attr.data-testid]="vm.slug">
  <div class="row">
    <div class="col-24">
      <h1 class="mlp-tray-title" data-testid="MarketingLandingPage.trayTitles">{{ vm.title }}</h1>
    </div>
  </div>
  <div class="row">
    <div class="col-24">
      <p class="mlp-tray-description">{{ vm.description }}</p>
    </div>
  </div>
  <div class="row studio-logo-wrapper">
    <div class="img-wrapper" *ngFor="let studioImg of orderedStudioImgs">
      <img
        osnSharedUseAsPicture
        [imgQuery]="imgQuery"
        class="col-xs-8 col-sm-4"
        [src]="studioImg.text"
        alt="Studio logo"
        data-testid="MarketingLandingPage.studioTrayContainerImages"
      />
    </div>
  </div>
  <div class="row">
    <div class="col-24 d-flex justify-content-center">
      <osn-shared-marketing-action-button
        *ngIf="vm.button"
        [actionButton]="vm.button"
        [buttonText]="buttonText"
        data-testid="MarketingLandingPage.studioTrayStartButton"
        (measureClick)="onStudioTrayButtonClick()"
      ></osn-shared-marketing-action-button>
    </div>
  </div>
</div>
